// colors generated by brand book colors (https://smart-swatch.netlify.app);

export const colors = {
  "brand": {
    fontColor: '#03354A',
    fontColorWhite: '#F1F9FF',
    offBlack: '#003349',
    yellow: '#FECB00',
    orange: '#ED9B33',
    blue: '#00358E',
    blueExtraDark: '#071c29',

    cyan: '#00B5E2',
    cyanOpacity: 'rgba(0, 181, 226, .85)',
    raspberry: '#BC204B',
    pink: '#F04E98',
    green: 'rgb(120, 214, 75)',
    white: '#FFFFFF',

    formPlaceholderColor: '#B5B5B5',
    formInputBgColor: '#F5F5F5',
    blueShadowColor: '#389BF834',

    gradientBlueLight: '#1D9CD2',
    gradientBlueDark: '#014297',

    // shadow
    blueShadow: '0px 20px 40px var(--chakra-colors-brand-blueShadowColor)',
  },
  "base": {
    50: '#dff8ff',
    100: '#b3e8ff',
    200: '#85d8fd',
    300: '#59c8fb',
    400: '#38b9fa',
    500: '#2a9fe1',
    600: '#1d7daf',
    700: '#10597e',
    800: '#00354d', // brand book
    900: '#00131d',
  },
  "orange": {
    50: '#fff3dd',
    100: '#fcdcb4',
    200: '#f6c687',
    300: '#f2af5a',
    400: '#ec982c', // brand book
    500: '#d37e13',
    600: '#a4620b',
    700: '#764606',
    800: '#482900',
    900: '#1c0c00',
  },
  "yellow": {
    50: '#fffada',
    100: '#fff0ad',
    200: '#ffe57d',
    300: '#ffdb4b',
    400: '#ffd11a',
    500: '#e6b700', // brand book
    600: '#b38f00',
    700: '#806600',
    800: '#4e3d00',
    900: '#1d1400',
  },
  "blue": {
    50: '#e0efff',
    100: '#b1cfff',
    200: '#80afff',
    300: '#4f8ffe',
    400: '#236ffd',
    500: '#0f56e4',
    600: '#0643b2',
    700: '#003080', // brand book          
    800: '#001d4f',
    900: '#000a1f',
  },
  "cyan": {
    50: '#d7fdff',
    100: '#aaf1ff',
    200: '#7ae7ff',
    300: '#48dbff',
    400: '#1ad1ff',
    500: '#00b8e6', // brand book
    600: '#008fb4',
    700: '#006682',
    800: '#003e50',
    900: '#001620',
  },
  "pink": {
    50: '#ffe4f3',
    100: '#fcb6d7',
    200: '#f688bb',
    300: '#f15a9f', // brand
    400: '#ec2d84',
    500: '#d3166a',
    600: '#a50e53',
    700: '#77073b',
    800: '#490223',
    900: '#1e000e',
  },
  "green": {
    50: '#eafce2',
    100: '#cdf2bd',
    200: '#b0e795',
    300: '#91de6d',
    400: '#73d444', // brand book
    500: '#59bb2b',
    600: '#44911f',
    700: '#306815',
    800: '#1b3f09',
    900: '#031700',
  },
  "red": {
    50: '#ffe5ef',
    100: '#f9bccd',
    200: '#ee91ab',
    300: '#e66589',
    400: '#de3b68',
    500: '#c4214e', // brand book
    600: '#9a183d',
    700: '#6f102b',
    800: '#440619',
    900: '#1d0009',
  }
}